<style lang="css" scope>
  .wz-comment-item {
      width: 50%;
      padding: 0.45rem 0.4rem;
      background: #fff url("../../assets/img/comment-item_bg.png") no-repeat;
      background-size: 100% 100%;
      height : 3.3rem;
      padding-top : 0.9rem;
  }
 /*  .wz-comment-item:nth-child(3n+0){
    margin-bottom: 0.3rem;
  } */
  .wz-comment-item:nth-child(4n+0){
    margin-bottom: 0.3rem;
  }
  .wz-comment-item .u-logo {
      width: 0.8rem;
      height: 0.8rem;
      float: left;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
  }
  .wz-comment-item .wz-comment-item__cont {
      
  }
  .wz-comment-item .cm-title {
    font-size: 0.24rem;
    color : #f12632;
  }
  .wz-comment-item .cm-body {
    padding-top: 0.15rem;
    padding-bottom: 0.15rem;
    font-size: 0.28rem;
    height: 1.1rem;
  }
  .wz-comment-item .cm-foot {
      text-align: right;
      color : #f12632;
  }
  .text-line {
    text-decoration: underline;
  }
</style>
<template>
  <div class="wz-comment-item">
    <slot name="head"></slot>
    <div class="wz-comment-item__cont">
      <div class="cm-title"><strong>祝：</strong> <span class="text-line">{{formatContent('name', comment.content)}}</span></div>
      <div class="cm-body"><strong>{{formatContent('comment', comment.content)}}</strong></div>
      <div class="cm-foot">
        <div>by:{{sUser.nick}}</div>
        <slot name="tool"><span></span></slot>
      </div>
    </div>
    <slot name="foot"></slot>
  </div>
</template>

<script>
  export default {
    name: 'wz-comment-item',
    data() {
      return {}
    },
    props: {
      comment: {type: Object, default: null},
      users: {type: Object, default: null}
    },
    computed: {
      // 评论者
      sUser() {
        return this.getUser('suid')
      },
      // 关联用户（评论对象所属于用户）
      rUser() {
        return this.getUser('ruid')
      },
      // 参与者
      jUser() {
        return this.getUser('juid')
      },
      // 发布时间
      ctime() {
        return this.getInfo('ctime', '')
      }
    },
    methods: {
      getInfo(key, defValue) {
        const {comment} = this
        return comment && comment[key] != null ? comment[key] : defValue
      },
      formatContent(type, con){
        let list, obj = {};
        if(type && con) {
          list = con.split('{:}')
          obj.name = list[0] || '老师'
          obj.comment = list[1] || '新的一年，顺风顺水！'
          return obj[type]
        }        
      },

      getUser(key) {
        const {users} = this
        const uid = this.getInfo(key, 0)
        return uid > 0 && users && users[uid]
          ? users[uid]
          : null
      }
    },
    created() {},
    beforeDestroy() {}
  }
</script>
